export default "__VITE_ASSET__DjoLQ53u__"